import React from 'react';
import { formatDateForBlog } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getCategoryName } from '../blogPostGrid/BlogPostGrid';

import moreTealArrow from '../../../content/media-library/icons/more-teal-arrow.svg';

const imageSrcFor = (post) => {
  const image = post.PreviewImage?.publicURL || post.FeaturedImage?.publicURL;
  return image.startsWith('/') ? image : `/blog/${post.slug}/${image}`;
};

const BlogPostPreviewCard = ({ blogPost, className, showDescription, showMedia, showCTA, showCategory }) => {
  const cardImageClasses = classNames('blog-post-preview-card__image');
  return (
    <article className={className} key={blogPost.slug}>
      <a href={`/blog/${blogPost.slug}/`}>
        {showMedia ? (
          <div className="blog-post-preview-card__media-wrapper">
            {blogPost.PreviewVideo ? (
              <video className="blog-post-preview-card__video" playsInline autoPlay loop muted>
                <source src={`https://media.starlingbank.com/videos/${blogPost.PreviewVideo}.webm`} type="video/webm" />
                <source src={`https://media.starlingbank.com/videos/${blogPost.PreviewVideo}.mp4`} type="video/mp4" />
              </video>
            ) : (
              <div
                className={cardImageClasses}
                title={blogPost.Title}
                {...{
                  style: { backgroundImage: `url(${imageSrcFor(blogPost)})` }
                }}
              />
            )}
          </div>
        ) : null}
        {showCategory ? (
          <div
            className={`blog-post-preview-card__category-wrapper category-color--${getCategoryName(
              blogPost.Categories[0]
            )}`}
          >
            <span className="blog-post-preview-card__category-bullet" />
            <p className="blog-post-preview-card__category-title">{blogPost.Categories[0] || 'General'}</p>
          </div>
        ) : null}
        <h3 className="blog-post-preview-card__title">{blogPost.PreviewTitle || blogPost.Title}</h3>
        {showDescription ? (
          <p className="blog-post-preview-card__description">{blogPost.Excerpt || blogPost.Description}</p>
        ) : null}
        <p className="blog-post-preview-card__date">{formatDateForBlog(blogPost.Date)}</p>
        {showCTA ? (
          <p className="find-more-link">
            <strong>Read more</strong>
            <img alt="arrow-right" src={moreTealArrow} />
          </p>
        ) : null}
      </a>
    </article>
  );
};

BlogPostPreviewCard.propTypes = {
  blogPost: PropTypes.object,
  className: PropTypes.string,
  showDescription: PropTypes.bool,
  showMedia: PropTypes.bool,
  showCTA: PropTypes.bool,
  showCategory: PropTypes.bool
};

export default BlogPostPreviewCard;
